module.exports = __webpack_public_path__ + "img/Table-selection.25e4feed.svg";